export const SET_DASHBOARD_SURVEYS = 'SET_DASHBOARD_SURVEYS'
export const SET_SURVEYS = 'SET_SURVEYS'

export const setDashboardSurveys = (surveys) => ({
  type: SET_DASHBOARD_SURVEYS,
  surveys,
})

export const setSurveys = (surveyInfo) => ({ type: SET_SURVEYS, surveyInfo })
